<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="客户信息id" prop="customerId">
          <el-input v-model="dataForm.customerId" placeholder="客户信息id"></el-input>
      </el-form-item>
          <el-form-item label="公司信息id" prop="companyId">
          <el-input v-model="dataForm.companyId" placeholder="公司信息id"></el-input>
      </el-form-item>
          <el-form-item label="产品id" prop="productId">
          <el-input v-model="dataForm.productId" placeholder="产品id"></el-input>
      </el-form-item>
          <el-form-item label="门店id" prop="deptId">
          <el-input v-model="dataForm.deptId" placeholder="门店id"></el-input>
      </el-form-item>
          <el-form-item label="撞库推送消息" prop="repeatPushMsg">
          <el-input v-model="dataForm.repeatPushMsg" placeholder="撞库推送消息"></el-input>
      </el-form-item>
          <el-form-item label="撞库返回消息" prop="repeatRespMsg">
          <el-input v-model="dataForm.repeatRespMsg" placeholder="撞库返回消息"></el-input>
      </el-form-item>
          <el-form-item label="撞库状态:0,成功,1:失败" prop="repeatStatus">
          <el-input v-model="dataForm.repeatStatus" placeholder="撞库状态:0,成功,1:失败"></el-input>
      </el-form-item>
          <el-form-item label="更新人" prop="updateBy">
          <el-input v-model="dataForm.updateBy" placeholder="更新人"></el-input>
      </el-form-item>
              <el-form-item label="更新日期" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="更新日期"></el-input>
      </el-form-item>
          <el-form-item label="删除日期" prop="deleteTime">
          <el-input v-model="dataForm.deleteTime" placeholder="删除日期"></el-input>
      </el-form-item>
          <el-form-item label="" prop="checkUrl">
          <el-input v-model="dataForm.checkUrl" placeholder=""></el-input>
      </el-form-item>
          <el-form-item label="" prop="city">
          <el-input v-model="dataForm.city" placeholder=""></el-input>
      </el-form-item>
          <el-form-item label="撞库价格" prop="price">
          <el-input v-model="dataForm.price" placeholder="撞库价格"></el-input>
      </el-form-item>
          <el-form-item label="返回上游价格" prop="channelPrice">
          <el-input v-model="dataForm.channelPrice" placeholder="返回上游价格"></el-input>
      </el-form-item>
          <el-form-item label="产品结算方式" prop="settlementMethod">
          <el-input v-model="dataForm.settlementMethod" placeholder="产品结算方式"></el-input>
      </el-form-item>
          <el-form-item label="请求ID" prop="orderId">
          <el-input v-model="dataForm.orderId" placeholder="请求ID"></el-input>
      </el-form-item>
          <el-form-item label="手机MD5" prop="phoneMd5">
          <el-input v-model="dataForm.phoneMd5" placeholder="手机MD5"></el-input>
      </el-form-item>
          <el-form-item label="推送内容" prop="content">
          <el-input v-model="dataForm.content" placeholder="推送内容"></el-input>
      </el-form-item>
          <el-form-item label="是否已推送1是0否" prop="isPush">
          <el-input v-model="dataForm.isPush" placeholder="是否已推送1是0否"></el-input>
      </el-form-item>
          <el-form-item label="推送返回状态码" prop="respCode">
          <el-input v-model="dataForm.respCode" placeholder="推送返回状态码"></el-input>
      </el-form-item>
          <el-form-item label="推送返回信息" prop="respMsg">
          <el-input v-model="dataForm.respMsg" placeholder="推送返回信息"></el-input>
      </el-form-item>
          <el-form-item label="推送时间" prop="pushDate">
          <el-input v-model="dataForm.pushDate" placeholder="推送时间"></el-input>
      </el-form-item>
          <el-form-item label="批次号" prop="batchId">
          <el-input v-model="dataForm.batchId" placeholder="批次号"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        customerId: '',
        companyId: '',
        productId: '',
        deptId: '',
        repeatPushMsg: '',
        repeatRespMsg: '',
        repeatStatus: '',
        updateBy: '',
        creator: '',
        createDate: '',
        updateTime: '',
        deleteTime: '',
        checkUrl: '',
        city: '',
        price: '',
        channelPrice: '',
        settlementMethod: '',
        orderId: '',
        phoneMd5: '',
        content: '',
        isPush: '',
        respCode: '',
        respMsg: '',
        pushDate: '',
        batchId: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        customerId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        companyId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deptId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        repeatPushMsg: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        repeatRespMsg: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        repeatStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        checkUrl: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        city: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        price: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        channelPrice: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        settlementMethod: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        orderId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        phoneMd5: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        content: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        isPush: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        respCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        respMsg: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pushDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        batchId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/mobilechecklog0512archive/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/mobilechecklog0512archive/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
